import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { IActivity, IExtEvent } from "./types"
import api from "services/api"

export function useToSubscribeActivities(
  sessionId: string,
  params?: any,
  config?: UseQueryOptions<IActivity[]>
) {
  return useQuery<IActivity[]>(
    [
      "tactical",
      "production",
      "sessions",
      "external",
      sessionId,
      "getCartActivities",
      params,
    ],
    {
      ...config,
    }
  )
}

export function useExtEvents(
  params: IPaginationParams & any,
  config?: UseQueryOptions<IExtEvent[]>
) {
  return useQuery<IExtEvent[]>(
    ["operation", "production", "events", "external", params],
    {
      ...config,
    }
  )
}

export function useAddActivityEventsToCart(
  { memberId, activityId }: { memberId: string; activityId: string },
  config?: UseMutationOptions<
    unknown,
    unknown,
    { session_id: string }
  >
) {
  const queryClient = useQueryClient()
  return useMutation<
    unknown,
    unknown,
    { session_id: string }
  >(
    (data) =>
      api.post(
        `operation/administration/members/portal/${memberId}/presubscriptions/cart_activity/${activityId}`,
        data
      ),
    {
      ...config,
      onSuccess(data, vars, context) {
        config?.onSuccess?.(data, vars, context)
        queryClient.invalidateQueries([
          "operation",
          "administration",
          "members",
          "portal",
          memberId,
          "presubscriptions",
          "cart",
        ])
        queryClient.invalidateQueries([
          "operation",
          "administration",
          "members",
          "portal",
          memberId,
          "to_subscribe_events",
        ])
        queryClient.invalidateQueries([
          "operation",
          "production",
          "events",
          "external",
        ])
      },
    }
  )
}
